// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { CustomAppState } from "@flip/App/Store/Reducers";
import { constants } from "@flip/XDL/constants";
import { xScreen } from "@flip/XDL/Utilities";
import useAppSelector from "@insite/client-framework/Common/Hooks/useAppSelector";
import { injectCss } from "@insite/mobius/utilities";
import { StyledProp } from "@insite/mobius/utilities/InjectableCss";
import MobiusStyledComponentProps from "@insite/mobius/utilities/MobiusStyledComponentProps";
import React, { FC } from "react";
import styled, { css } from "styled-components";

interface XngStickyProps {
    css?: StyledProp<XngStickyComponentProps>;
    stickyOffset?: string;
    stopBreakpoint?: "xs" | "sm" | "md" | "lg" | "xl" | 767;
    [key: string]: any;
    isCheckoutPge?: boolean;
}

export type XngStickyComponentProps = MobiusStyledComponentProps<"div", XngStickyProps>;

const XngStickyWrapper = styled.div<XngStickyComponentProps>`
    position: sticky;
    top: ${({ stickyOffset }) => `${stickyOffset}`};
    ${({ stopBreakpoint }) => css`
        ${xScreen("lte", stopBreakpoint || 767)} {
            position: static;
        }
    `};
    @media print {
        position: static;
    }

    ${injectCss}
`;

const XngSticky: FC<XngStickyProps> = ({ stickyOffset, isCheckoutPge, ...otherProps }) => {
    const stickyHeader = useAppSelector(
        state => {
            const isTabletScreen = (state as CustomAppState).xCommon.isTabletScreen;
            return  isCheckoutPge ? `${constants.checkoutHeader.size.sticky}px` : isTabletScreen ? `${constants.header.tablet.size.height}px` : ((state as CustomAppState).xHeader.stickyHeader || `66px`);           
        }
    );
    
    return <XngStickyWrapper {...otherProps} stickyOffset={`${parseFloat(stickyHeader) + 20}px`} />;
};

XngSticky.defaultProps = {
    className: "xng-sticky",
    stopBreakpoint: 767,
};

export default XngSticky;
